
import { motion} from "framer-motion";
import { Link } from "react-router-dom";

function Aboutinfo() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-white">
  <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 
                  grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 xl:gap-16 items-center">
       <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >

          <h2 className="text-[clamp(28px,3.5vw,52px)] font-bold text-[#1a1a1a] leading-tight mb-5 sm:mb-6">
            Comprehensive{" "}
            <span className="text-[#c021d6]">Engineering</span> Solutions
          </h2>
          <p className="text-gray-500 leading-relaxed mb-7 sm:mb-8 text-sm sm:text-base xl:text-[17px]">
            We are assisting businesses across the globe from concept to manufactering-ready solutions.
          </p>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 border-2 border-[#c021d6] text-[#c021d6] font-semibold px-5 sm:px-6 py-2.5 rounded-full hover:bg-[#c021d6] hover:text-white transition-all text-sm sm:text-base"
          >
            About Us
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative"
        >
          <motion.div
            className="rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl h-60 sm:h-72 lg:h-80 xl:h-96 cursor-pointer"
            whileHover={{ scale: 1.04 }}
            transition={{ duration: 0.3 }}
          >
            <img
              src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&auto=format&fit=crop"
              alt="Engineering work"
              className="w-full h-full object-cover"
            />
          </motion.div>
          <div className="absolute -top-4 -right-4 w-16 h-16 sm:w-24 sm:h-24 bg-purple-100 rounded-full -z-10" />
          <div className="absolute -bottom-4 -left-4 w-12 h-12 sm:w-16 sm:h-16 bg-[#c021d6]/10 rounded-full -z-10" />
        </motion.div>
      </div>
    </section>
  );
}
export default Aboutinfo;